import * as angular from "angular";
import template from "./entity-schema-values.html";
import "./entity-schema-values.less";
import {
	buildEntitySchemaDisplay,
	formatEntitySchemaValue
} from "../entitySchemaDisplayModel";
import { formatArrayTableCell } from "../../../../../../../extensions/json-schema/arrayTableModel";

export function controller() {
	const ctrl = this;

	ctrl.$onInit = syncDisplay;
	ctrl.$onChanges = onChanges;
	ctrl.formatValue = formatEntitySchemaValue;
	ctrl.formatTableCell = formatArrayTableCell;

	function onChanges(changes) {
		if((changes.schema && !changes.schema.isFirstChange())
			|| (changes.model && !changes.model.isFirstChange())) {
			syncDisplay();
		}
	}

	function syncDisplay() {
		ctrl.display = buildEntitySchemaDisplay(ctrl.schema, ctrl.model);
	}
}

export default angular
	.module("vesl.components.entity-schema-values", [])
	.component("entitySchemaValues", {
		controller,
		template,
		bindings: {
			schema: "<",
			sectionKey: "<",
			model: "<"
		}
	})
	.name;
